<div class="ct-page">

  <!-- Header -->
  <header class="ct-page__header">
    <div class="ct-page__header-left">
      <div class="ct-page__icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/>
          <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/>
        </svg>
      </div>
      <div>
        <h1 class="ct-page__title">Comptes</h1>
        <p class="ct-page__desc">Gérez les comptes comptables de votre application.</p>
      </div>
    </div>
    <app-ui-button
      label="Ajouter un compte"
      variant="primary"
      size="md"
      iconLeft="add_circle_outline"
      type="button"
      (clicked)="openAddEntityModal(true)"
    ></app-ui-button>
  </header>

  <!-- Card / Table -->
  <div class="ct-card">
    @if (isLoading) {
      <div class="ct-loader-wrapper">
        <app-loaderIntervantion [isLoading]="isLoading" [rows]="6"></app-loaderIntervantion>
      </div>
    } @else {
      <div class="ct-card__toolbar">
        <div class="ct-card__toolbar-left">
          <span class="ct-badge">{{ entities.length }}</span>
          <span class="ct-card__count">
            compte{{ entities.length > 1 ? 's' : '' }} enregistré{{ entities.length > 1 ? 's' : '' }}
          </span>
        </div>
      </div>

      @if (!entities.length) {
        <div class="ct-empty">
          <div class="ct-empty__icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/>
              <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/>
            </svg>
          </div>
          <p class="ct-empty__title">Aucun compte</p>
          <p class="ct-empty__hint">Commencez par en ajouter un en cliquant sur le bouton ci-dessus.</p>
        </div>
      } @else {
        <app-ui-table
          [columns]="tableEntity"
          [data]="entities"
          [actions]="rowActions"
        />
      }
    }
  </div>

  <!-- Row actions template -->
  <ng-template #rowActions let-item="item">
    <div class="ct-row-actions">
      <app-ui-button
        iconOnly="add"
        variant="ghost"
        size="sm"
        ariaLabel="Ajouter un sous-compte"
        type="button"
        (clicked)="openAddEntityModal(false, item)"
      ></app-ui-button>
      <app-ui-button
        iconOnly="edit"
        variant="ghost"
        size="sm"
        ariaLabel="Modifier"
        type="button"
        (clicked)="onEditEntity(item)"
      ></app-ui-button>
      <app-ui-button
        iconOnly="delete"
        variant="danger"
        size="sm"
        ariaLabel="Supprimer"
        type="button"
        (clicked)="openDeleteConfirm(item)"
      ></app-ui-button>
    </div>
  </ng-template>

</div>

<!-- Confirm Dialog -->
<app-confirm-dialog
  [isVisible]="showDeleteConfirm"
  [itemLabel]="selectedItem?.intitule || selectedItem?.code || ''"
  [isLoading]="deleteLoading"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete()"
></app-confirm-dialog>

<!-- Modal Ajout / Édition -->
<app-modal
  [isVisible]="showAddEntityModal"
  [title]="isEditing ? 'Modifier le compte' : (isAddParent ? 'Nouveau compte' : 'Nouveau sous-compte')"
  (closeEvent)="closeAddEntityModal()"
>
  <form [formGroup]="entityForm" (ngSubmit)="saveEntity()" class="ct-form">

    @if (isEditing && editingEntity) {
      <div class="ct-edit-banner">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
          <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
        Modification de <strong>{{ editingEntity.intitule || editingEntity.code }}</strong>
      </div>
    }

    @if (!isEditing && !isAddParent) {
      <div class="ct-sub-banner">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
        Ajout d'un sous-compte
      </div>
    }

    @if (!isAddParent) {
      <div class="ct-form__field">
        <app-input label="Compte parent" type="text" formControlName="parentDisplay"/>
        <input type="hidden" formControlName="parentId"/>
      </div>
    }

    <div class="ct-form__field">
      <app-input
        label="Code"
        type="number"
        formControlName="code"
        [thousandSeparator]="true"
      />
      @if (entityForm.get('code')?.invalid && (entityForm.get('code')?.dirty || entityForm.get('code')?.touched)) {
        <span class="ct-form__error">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          Le code est requis.
        </span>
      }
    </div>

    <div class="ct-form__field">
      <app-input
        label="Intitulé du compte"
        placeholder="Ex : Immobilisations corporelles"
        type="text"
        formControlName="intituler"
      />
      @if (entityForm.get('intituler')?.invalid && (entityForm.get('intituler')?.dirty || entityForm.get('intituler')?.touched)) {
        <span class="ct-form__error">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          L'intitulé est requis.
        </span>
      }
    </div>

    <div class="ct-form__field">
      <app-select
        label="Type de compte"
        formControlName="typeCompte"
        [options]="typeComptes"
      />
      @if (entityForm.get('typeCompte')?.invalid && (entityForm.get('typeCompte')?.dirty || entityForm.get('typeCompte')?.touched)) {
        <span class="ct-form__error">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          Le type de compte est requis.
        </span>
      }
    </div>

    <div class="ct-form__field">
      <app-input
        label="Solde"
        type="text"
        formControlName="solde"
        [thousandSeparator]="true"
      />
    </div>

    <div class="ct-form__actions">
      <app-ui-button
        label="Annuler"
        variant="ghost"
        size="md"
        type="button"
        (clicked)="closeAddEntityModal()"
      ></app-ui-button>
      <app-ui-button
        [label]="isEditing ? 'Mettre à jour' : 'Enregistrer'"
        variant="primary"
        size="md"
        [iconLeft]="isEditing ? 'check' : 'save'"
        type="submit"
        [loading]="isLoading"
        [disabled]="isLoading || entityForm.invalid"
      ></app-ui-button>
    </div>

  </form>
</app-modal>